<div class="dropdown-wrapper">
  <label>{{ label }}</label>

  <!-- Select UI -->
  <div class="custom-select" [class.invalid]="invalid" (click)="toggleDropdown()">
    <span [class.placeholder]="!selectedLabel">
      {{ selectedLabel || placeholder }}
    </span>
  </div>

  <!-- Dropdown Panel -->
  <div class="dropdown-panel" *ngIf="showDropdown">
    <input
      type="text"
      class="dropdown-search"
      placeholder="Search..."
      [(ngModel)]="searchText"
      [ngModelOptions]="{ standalone: true }"
      (click)="$event.stopPropagation()"
      *ngIf="showSearch"
    />

    <div class="dropdown-list">
      <div
        class="dropdown-item"
        *ngFor="let item of filteredItemsList"
        (click)="selectItem(item)"
      >
        {{ item[bindLabel] }}
      </div>
    </div>
  </div>

  <div class="error-message" *ngIf="control?.touched && control?.invalid">
    {{ errorMessage }}
  </div>
</div>
